(function() {
	let produtos = $('#produtos');
	let indicators = $('#syncProdutos');
	let indicatorItems = indicators.find('a[data-slide-to]');

	indicatorItems.click(function(e) {
		e.preventDefault();
	})

	produtos.on('slide.bs.carousel', function(e) {
		let to = e.to;

		indicatorItems.removeClass('active');
		indicators.find(`[data-slide-to="${to}"]`).addClass('active');
	});
})();
